import getFullTextFromEditorState from 'components/BasicEditor/lib/get-full-text-from-editor-state';
import {ContentState, EditorState} from 'draft-js';
import countTextEditorLines from './count-text-editor-lines';

export function getCompositionTotalOfLines(compositionRaw: string) {
  const editorState = EditorState.createWithContent(
    ContentState.createFromText(compositionRaw ?? ''),
  );

  return countTextEditorLines(getFullTextFromEditorState(editorState)) ?? 0;
}
